import { FormikProps } from "formik";
import { useContext } from "react";
import {
  BlankMediaPeriodInfo,
  BlankMediaTypeCommonDataViewModel,
  EquipmentItemViewModel,
  ItemViewModel,
  SubmitBlankMediaImporterApplication,
} from "../../../../../generated/data-contracts";
import { IUrlParamsBlankMedia } from "../../../../../models";
import { NotPortalReportMessage } from "../../../../shared/components/form";
import { AvisContext } from "../../../../shared/context";
import { CommonData } from "../forms/CommonDataForm";
import { NoDealCheckbox } from "../forms/NoDealCheckbox";
import { ApplicationSections } from "./sections/ApplicationSections";

interface IBlankMediaTypeImporterApplicationFormProps {
  applicationData: BlankMediaTypeCommonDataViewModel | undefined;
  bag: FormikProps<SubmitBlankMediaImporterApplication>;
  equipments: EquipmentItemViewModel[] | undefined;
  periodInfo: BlankMediaPeriodInfo | undefined;
  countries: ItemViewModel[] | undefined;
  professionalUsers: ItemViewModel[] | undefined;
  manufacturers: ItemViewModel[] | undefined;
  sectionsVisible: boolean | undefined;
  noDealAccepted: boolean;
  hasNoPortalReport: boolean | undefined;
  setNoDealAccepted: React.Dispatch<React.SetStateAction<boolean>>;
  urlParams: IUrlParamsBlankMedia;
  disabled: boolean | undefined;
  loading: boolean | undefined;
  onPeriodChange?: (dateFrom?: Date, dateTo?: Date) => void;
}
export function BlankMediaTypeImporterApplicationForm(
  props: Readonly<IBlankMediaTypeImporterApplicationFormProps>,
) {
  const {
    applicationData,
    bag,
    periodInfo,
    equipments,
    countries,
    professionalUsers,
    manufacturers,
    sectionsVisible,
    noDealAccepted,
    hasNoPortalReport,
    setNoDealAccepted,
    urlParams,
    disabled,
    loading,
    onPeriodChange,
  } = props;
  const { res } = useContext(AvisContext);

  return (
    <div className="blank-media-importer-application">
      <CommonData
        applicationData={applicationData}
        bag={bag}
        periodInfo={periodInfo}
        sectionsVisible={sectionsVisible}
        firstLoad={bag.values === null}
        loading={loading}
        title={res("blankMedia_Application_Title_I")}
        textToDisplay="portal_TDN_ImporterReport"
        urlParams={urlParams}
        disabled={disabled || hasNoPortalReport}
        onPeriodChange={onPeriodChange}
      >
        {!hasNoPortalReport && (
          <NoDealCheckbox
            bag={bag}
            loading={loading}
            textToDisplayKey="portal_TDN_ImporterReport_DealNotOccuredPortal"
            sectionsVisible={sectionsVisible}
            noDealAccepted={noDealAccepted}
            setNoDealAccepted={setNoDealAccepted}
            disabled={disabled || loading}
          />
        )}
      </CommonData>

      {hasNoPortalReport && <NotPortalReportMessage />}
      {sectionsVisible && !hasNoPortalReport && (
        <ApplicationSections
          bag={bag}
          equipments={equipments}
          countries={countries}
          professionalUsers={professionalUsers}
          manufacturers={manufacturers}
          disabled={disabled}
          loading={loading}
        />
      )}
    </div>
  );
}
